import React from 'react';
import HeaderBar from './Components/HeaderBar';
import NavBar from './Components/NavBar';
import Content from './Components/Content';

export default class MainUI extends React.Component {
    constructor(props) {
        super(props);

        this.submitButtonRef = React.createRef();
    }

    componentDidMount() {
        try {
            window.opener.location.reload();
        } catch(error) {}
    }

    render() {
        return (
            <div className="container-fluid reading-qa">
                <HeaderBar />
                <NavBar submitButtonRef={this.submitButtonRef} />
                <Content submitButtonRef={this.submitButtonRef} />
                <div className="loading-indicator">
                    <div className="spinner" />
                </div>
            </div>
        );
    }
}
